<template>
  <div class="notification">
    <p>
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "MyNotification",
};
</script>

<style>
.notification {
  border-radius: 15px;
  background: #ffcc00;
  color: black;
  padding: 12px 16px;
  width: fit-content;
  font-size: 13px;
  font-weight: 600;

  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: fixed;
  bottom: 5px;
  left: 46%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
</style>
